import { render } from 'react-dom';
import { Provider } from 'react-redux';
import AuthHandler from './AuthHandler';
import './index.css';
import { createStore } from './redux/store';
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';
import { getLDClientId } from './helpers/env';

const store = createStore();

(async () => {
    const LDProvider = await asyncWithLDProvider({
        clientSideID: getLDClientId,
    });
    render(
        <Provider store={store}>
            <LDProvider>
                <AuthHandler />
            </LDProvider>
        </Provider>,
        document.getElementById('app')
    );
})();
